import OrderPage from './OrderPage';
import orderPageReducer from './reducer';

export { orderPageReducer };
export default OrderPage;
